import React, { useEffect, useRef, useState } from "react";
import { TitleBar } from "../../Components/Common/TitleBar/titleBar";

import {
  Card,
  CardBody,
  Container,
  Table,
  Nav,
  NavItem,
  NavLink,
  Tooltip,
  Spinner,
  Button,
} from "reactstrap";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import FeatherIcon from "feather-icons-react";
import { TripModal } from "../../Components/Common/TripModal/tripModal";
import "./style.scss";
import { Pagination } from "../../Components/Common/Pagination";
import TruckIcon from "../../assets/images/svg/Truck.svg";
import { useDispatch, useSelector } from "react-redux";
import { getAllTripsRealTimeList } from "../../slices/realTimeTripDetail/thunk";
import DriverIcon from "../../assets/images/svg/Driver.svg";
import Location from "../../assets/images/svg/Location.svg";
import Route from "../../assets/images/svg/route.svg";
import Fuel from "../../assets/images/svg/fuel.svg";
import Plus from "../../assets/images/svg/plus.svg";
import Human from "../../assets/images/svg/Human.svg";
import Distance from "../../assets/images/svg/locationpin.svg";
import DeliveryTruck from "../../assets/images/svg/delivery-truck.svg";
import Action from "../../assets/images/svg/Action.svg";
import { useNavigate } from "react-router-dom";
const InRealTime = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const realTimeTripList = useSelector((state) => state.RealTimeTrip.tripList);

  const loading = useSelector((state) => state.RealTimeTrip.loading);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [viewDetails, setViewDetails] = useState(false);
  const [tripDetails, setTripDetails] = useState({});
  const [activeTab, setActiveTab] = useState("State");
  const [tooltipOpenId, setTooltipOpenId] = useState(null);

  const mapRef = useRef(null);
  const toggleViewDetailModal = (data) => {
    setTripDetails(data);
    setViewDetails(!viewDetails);
  };

  const toggleTooltip = (id, data) => {
    setTooltipOpenId((prev) => (prev === id ? null : id));
    setTripDetails(data);
  };

  const toggleSwitch = () => {
    setIsSwitchOn(!isSwitchOn);
  };

  const toggleModal = (data) => {
    setIsModalOpen(!isModalOpen);
    setTripDetails(data);
  };

  const handleOpenInNewTab = () => {
    navigate("/map-view");
  };
  document.title = "Real Time | D&A - Admin";

  const getCustomIcon = (url) =>
    new L.Icon({
      iconUrl: url || TruckIcon,
      iconSize: [34, 34],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
      className: "leaflet-truck-icon",
    });

  const focusOnMarker = (lat, lng) => {
    const map = mapRef.current;
    const latNum = parseFloat(lat);
    const lngNum = parseFloat(lng);

    if (map) {
      map.flyTo([latNum + 0.001, lngNum - 0.003], 16, { duration: 1.5 });
    }
  };

  useEffect(() => {
    try {
      dispatch(getAllTripsRealTimeList());
    } catch (error) {}

    const interval = setInterval(() => {
      try {
        dispatch(getAllTripsRealTimeList());
        setTooltipOpenId(null);
      } catch (error) {}
    }, 60000);
    return () => clearInterval(interval);
  }, [dispatch]);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const reversedTripList = [...realTimeTripList].reverse();
  const paginatedData = reversedTripList.slice(startIndex, endIndex);

  return (
    <React.Fragment>
      <div className="page-content realtime-page">
        <div className="map_Wrapper">
          <MapContainer
            center={[45.4654, 9.1859]}
            zoom={7}
            ref={mapRef}
            zoomControl={false}
            className="map_container"
            whenCreated={(mapInstance) => {
              mapRef.current = mapInstance;
            }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Button
              className="tripMapButton"
              onClick={() => handleOpenInNewTab()}
            >
              Open in Full Map View
            </Button>
            {paginatedData.map((trip, index) => {
              const icon = getCustomIcon(trip.icon_url);
              return (
                <Marker
                  key={index}
                  position={[trip.lat, trip.lng]}
                  icon={icon}
                  eventHandlers={{
                    mouseover: (e) => {
                      e.target.openPopup();
                    },
                    mouseout: (e) => {
                      e.target.closePopup();
                    },
                    click: () => {
                      focusOnMarker(trip.lat, trip.lng);
                    },
                  }}
                >
                  <Popup
                    closeButton={false}
                    autoPan={false}
                    className="leaflet-popup-content-wrapper"
                  >
                    <div className="leaflet-popup-content">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex gap-2">
                          <div className="popup-index-box">29</div>
                          <div className="popup-index-content">
                            <h5>Cebotari Gicu (FG598RC)</h5>
                            <span>1000007491960</span>
                          </div>
                        </div>

                        <FeatherIcon
                          icon="x"
                          size={16}
                          className=""
                          onClick={() => mapRef.current.closePopup()}
                          style={{
                            cursor: "pointer",
                            marginRight: "10px",
                            marginTop: "0px",
                            width: "24px",
                            height: "24px",
                          }}
                        />
                      </div>
                    </div>

                    <div className="activeTabContent activeTabContainer">
                      <Nav tabs className="headerTabs_Map_Container">
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              setActiveTab("State");
                            }}
                            className={
                              activeTab === "State" ? "active-tab" : ""
                            }
                          >
                            State
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              setActiveTab("Write");
                            }}
                            className={
                              activeTab === "Write" ? "active-tab" : ""
                            }
                          >
                            Write
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            onClick={() => {
                              setActiveTab("Indications");
                            }}
                            className={
                              activeTab === "Indications" ? "active-tab" : ""
                            }
                          >
                            Indications
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            onClick={() => {
                              setActiveTab("Ad POI");
                            }}
                            className={
                              activeTab === "Ad POI" ? "active-tab" : ""
                            }
                          >
                            Ad POI
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>

                    {activeTab === "State" ? (
                      <div>
                        <div className="d-flex align-items-start gap-2 popup-state-section">
                          <img
                            src={Location}
                            alt=""
                            className="popup-state-section-img"
                          />

                          <div>
                            <span className="popup-state-section-1">
                              15-050202516:30
                            </span>
                            <br />
                            <span className="popup-state-section-2">
                              E76, 55011 Capannori LU, Italy
                            </span>
                            <br />
                            <span className="popup-state-section-3">
                              On the move85.6km/h -Km Odometer: 1.021.963.6
                            </span>
                          </div>
                        </div>

                        <div className="d-flex align-items-start gap-1 gap-lg-2 popup-icon-row">
                          <img
                            src={Route}
                            alt=""
                            style={{ width: "24px", height: "24px" }}
                          />
                          <div>
                            <div className="d-flex justify-content-between gap-2">
                              <span className="notifyLabel">
                                Driver commitment hours:
                              </span>
                              <span className="notifyValue">08:00</span>
                            </div>

                            <div className="d-flex justify-content-between">
                              <span className="notifyLabel">
                                Driver driving hours:
                              </span>
                              <span className="notifyValue">
                                05:55 - 380.9 Km
                              </span>
                            </div>

                            <div className="d-flex justify-content-between">
                              <span className="notifyLabel">
                                Remaining guide:
                              </span>
                              <span className="notifyValue">to rest 04:05</span>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2 popup-icon-row">
                          <img
                            src={Fuel}
                            alt=""
                            className="popup-icon-row-img"
                          />
                          <div>
                            <span
                              style={{
                                fontWeight: "600",
                                fontSize: "12px",
                                color: "#161616",
                              }}
                            >
                              Show nearby stations
                            </span>
                          </div>
                        </div>

                        <div className="d-flex  align-items-center gap-3 popUp-icons-item">
                          <div className="d-flex align-items-center gap-3">
                            <img
                              src={Plus}
                              alt="Plus icon"
                              style={{ width: "24px", height: "24px" }}
                            />
                            <span className="popup-detail-item span">
                              DetailPathStreet
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <img
                              src={Human}
                              alt="Human icon"
                              style={{ width: "24px", height: "24px" }}
                            />
                            <span className="popup-detail-item span">
                              DetailPathStreet
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </Popup>
                </Marker>
              );
            })}
          </MapContainer>
          <Container fluid className="mapTableContainer">
            <div className="d-flex flex-column">
              <div className="full_screen_view">
                <TitleBar title={"Real time trip list"} isRealTime={true} />

                <Card className="realTimeTripCard">
                  <CardBody>
                    <div className="input-group search-bar">
                      <span className="input-group-text bg-light border-0">
                        <i className="ri-search-line text-muted"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control bg-light border-0"
                        placeholder="Search input text"
                      />
                    </div>
                    <div className="table_wrapper">
                      <div className="realtimetable">
                        <Table className="mb-0" striped>
                          <thead>
                            <tr>
                              <th className="tableHeaderText"></th>
                              <th className="tableHeaderText">
                                <img
                                  src={DeliveryTruck}
                                  style={{ width: "24px", height: "24px" }}
                                  alt=""
                                />
                              </th>
                              <th className="tableHeaderText">
                                <img src={DriverIcon} alt="" />
                              </th>
                              <th className="tableHeaderText">
                                <img
                                  src={Distance}
                                  alt=""
                                  style={{ width: "24px", height: "24px" }}
                                />
                              </th>
                              <th className="tableHeaderText">
                                <img
                                  src={Action}
                                  alt=""
                                  style={{ width: "24px", height: "24px" }}
                                />
                              </th>
                            </tr>
                          </thead>
                          {loading.tripList ? (
                            <tbody>
                              <tr>
                                <td
                                  colSpan="8"
                                  className="text-center align-middle"
                                >
                                  <Spinner color="primary" />
                                </td>
                              </tr>
                            </tbody>
                          ) : paginatedData.length > 0 ? (
                            <tbody>
                              {paginatedData.map((trip, index) => {
                                const tooltipId = `truckNameTooltip-${index}`;
                                const firstName =
                                  trip.truck_name?.split(" ")[0] || "-";
                                const remainingName =
                                  trip.truck_name
                                    ?.split(" ")
                                    .slice(1)
                                    .join(" ") || "-";

                                return (
                                  <tr key={index}>
                                    <td className="tableBodyText">
                                      <img
                                        src={trip.icon_url}
                                        alt=""
                                        style={{
                                          width: "32px",
                                          height: "32px",
                                        }}
                                      />
                                    </td>

                                    <td
                                      className="tableBodyText"
                                      id={tooltipId}
                                    >
                                      {trip.truck_name ? (
                                        <>
                                          <div>
                                            <span
                                              style={{
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {firstName}
                                            </span>
                                            <Tooltip
                                              placement="top"
                                              isOpen={tooltipOpenId === trip.id}
                                              target={tooltipId}
                                              toggle={() =>
                                                toggleTooltip(trip.id, trip)
                                              }
                                              className="custom-tooltip"
                                              autohide={false}
                                            >
                                              <div className="tooltip-row">
                                                <span className="tooltip-label">
                                                  Truck Name
                                                </span>
                                                <span className="tooltip-value">
                                                  {tripDetails.truck_name ||
                                                    "-"}
                                                </span>
                                              </div>
                                              <div className="tooltip-row">
                                                <span className="tooltip-label">
                                                  Driver Name
                                                </span>
                                                <span className="tooltip-value">
                                                  {tripDetails.driver || "-"}
                                                </span>
                                              </div>
                                              <div className="tooltip-row">
                                                <span className="tooltip-label">
                                                  Distance (km)
                                                </span>
                                                <span className="tooltip-value">
                                                  {tripDetails.distance_km ||
                                                    "-"}
                                                </span>
                                              </div>
                                              <div className="tooltip-row">
                                                <span className="tooltip-label">
                                                  Speed
                                                </span>
                                                <span className="tooltip-value">
                                                  {tripDetails.speed || "-"}
                                                </span>
                                              </div>
                                              <div className="tooltip-row">
                                                <span className="tooltip-label">
                                                  Hours
                                                </span>
                                                <span className="tooltip-value">
                                                  {tripDetails.hours || "-"}
                                                </span>
                                              </div>
                                              <div className="tooltip-row">
                                                <span className="tooltip-label">
                                                  Satellite Count
                                                </span>
                                                <span className="tooltip-value">
                                                  {tripDetails.satellite_count ||
                                                    "-"}
                                                </span>
                                              </div>
                                              <div className="tooltip-row no-border">
                                                <span className="tooltip-label">
                                                  Location
                                                </span>
                                                <span className="tooltip-value location">
                                                  {tripDetails.location || "-"}
                                                </span>
                                              </div>
                                            </Tooltip>
                                          </div>
                                          <div className="table_text">
                                            {remainingName !== "-"
                                              ? remainingName + "..."
                                              : "-"}
                                          </div>
                                        </>
                                      ) : (
                                        "-"
                                      )}
                                    </td>

                                    <td className="tableBodyText">
                                      {trip.driver
                                        ? trip.driver.length > 5
                                          ? `${trip.driver.slice(0, 5)}...`
                                          : trip.driver
                                        : "-"}
                                    </td>

                                    <td className="tableBodyText">
                                      {trip.distance_km || "-"}
                                    </td>
                                    <td>
                                      <div className="d-flex justify-content-center align-items-center gap-1">
                                        <FeatherIcon
                                          icon="bell"
                                          onClick={() => toggleModal(trip)}
                                          className={`cursor-pointer text-${
                                            trip.status === "red"
                                              ? "danger"
                                              : trip.status === "yellow"
                                              ? "warning"
                                              : "dark"
                                          }`}
                                        />
                                        <i
                                          onClick={() =>
                                            focusOnMarker(trip.lat, trip.lng)
                                          }
                                          className="ri-external-link-line cursor-pointer"
                                          style={{
                                            fontSize: "22px",
                                            color: "#0F62FE",
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          ) : (
                            <tbody>
                              <tr>
                                <td
                                  className="text-start text-sm-center"
                                  colSpan={7}
                                >
                                  <h3>No Roles Found</h3>
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </Table>
                      </div>
                    </div>
                    {realTimeTripList.length > 0 && (
                      <Pagination
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        totalItems={realTimeTripList.length}
                        realtimedropDownWrapper="realtimedropDownWrapper"
                        realtimepaginationDropdown="realtimepaginationDropdown"
                        realtimepaginationText="realtimepaginationText"
                        realtimepageDropdown="realtimepageDropdown"
                        realtimepageText="realtimepageText"
                        realtimepagePrev="realtimepagePrev"
                        realtimepageNext="realtimepageNext"
                      />
                    )}
                  </CardBody>
                </Card>
              </div>
            </div>
          </Container>
        </div>

        <TripModal
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          buttonText="OK"
          title={"Real-time travel"}
          tripText={`Trip ID: ${tripDetails?.id || "-"}`}
          isRealTime={true}
        >
          <div className="px-3 d-flex flex-column gap-1 gap-sm-4">
            <span>There is an alarm connected to this trip. </span>
            <span>Solve the problem!</span>
            <span>
              Is the problem solved? . Only in this case do you turn off the
              alarm.{" "}
            </span>

            <div className="switch-container">
              <div
                className={`custom-switch ${isSwitchOn ? "on" : "off"}`}
                onClick={toggleSwitch}
              >
                <div className="switch-toggle">
                  {isSwitchOn ? (
                    <FeatherIcon icon="check" size={12} />
                  ) : (
                    <FeatherIcon icon="x" size={12} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </TripModal>

        <TripModal
          isModalOpen={viewDetails}
          toggleModal={toggleViewDetailModal}
          buttonText="Assign"
          closeText={"Close without saving"}
          title={"In real time"}
          tripText={"Trip Details"}
          showButtons={false}
          showDeleteIcon={false}
          showEditIcon={false}
          isRealTime={true}
        ></TripModal>
      </div>
    </React.Fragment>
  );
};

export default InRealTime;
